module.exports = __webpack_public_path__ + "img/md-heart-empty.8b8cfd84.svg";